var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 600,
    viewBox: "0 0 240 120",
    fill: "#00f",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h240v120H0Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h240v80H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h240v40H0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.3914 0 0 .3914 60 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-37.175-94.368a92.195 92.195 0 0 1 74.35 0Q43-12 0-1q-43-11-37.175-93.368Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m0-84.5 1.125 2.551 2.772-.301L2.25-80l1.647 2.25-2.772-.301L0-75.5l-1.125-2.551-2.772.301L-2.25-80l-1.647-2.25 2.772.301",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: -10.5,
    y: -14
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 10.5,
    y: -14
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0-70 9 18 6-8 15 20a10 10 0 0 1-.385 2.747A46.4 46.4 0 0 1 0-6.09a46.4 46.4 0 0 1-29.615-31.162A10 10 0 0 1-30-40l15-20 6 8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M-29.615-37.253A10 10 0 0 0-15-31.34a10 10 0 0 1 10 0 10 10 0 0 0 10 0 10 10 0 0 1 10 0 10 10 0 0 0 14.615-5.913l.385.14v7.32a10 10 0 0 0-5 1.34 10 10 0 0 1-10 0 10 10 0 0 0-10 0 10 10 0 0 1-10 0 10 10 0 0 0-10 0 10 10 0 0 1-10 0 10 10 0 0 0-5-1.34v-7.32"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 5.774
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40-93.066a92.195 92.195 0 0 1 2.825-1.302l2.97 47.449A49.301 49.301 0 0 0 0-3.036 49.301 49.301 0 0 0 34.205-46.92l2.97-47.45A92.195 92.195 0 0 1 40-93.065l-2.9 46.328A52.202 52.202 0 0 1 0 0a52.202 52.202 0 0 1-37.1-46.738Z",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/si.6de5935d75318e68c1d028baecd4feeb.svg";
export { ForwardRef as ReactComponent };